import React, { FC } from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';

import { pages } from '@/settings/pages';
import logo from '@/assets/logo/logo.png';
import logoEn from '@/assets/logo/logo_en.png';

type Props = {
  language: string;
};

export const LogoContents: FC<Props> = ({ language }) => (
  <LogoItem>
    <StyledLink to={pages.top}>
      {language === 'en' ? <Logo src={logoEn} /> : <Logo src={logo} />}
    </StyledLink>
  </LogoItem>
);

const LogoItem = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 24px;
  @media (max-width: 780px) {
    padding-right: 0px;
  }
`;

const StyledLink = styled(Link)`
  position: relative;
`;

const Logo = styled.img`
  width: 289px;
  height: 30px;
`;
